import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsServiceHubsRoute: InvariantJiraRoute = {
	exact: true,
	name: 'customer-service-helpcenter',
	path: '/jira/helpcenter',
};
